import i18nFactory from '@yandex-int/i18n';

import { getEnumSetFrom } from '../../service/CastHelpers';
import {
    validateEnumValue,
    validatePositiveNumberSetValue
} from '../../service/ValidationHelpers/ValidationHelpers';
import {
    Criteria,
    CriteriaContainer,
    CriteriaType
} from '../../typings/filter';
import {
    FiltersForGeneralGroup,
    FiltersForStatusesGroup
} from '../../typings/log';

import * as keyset from './log-filters.i18n';

const i18n = i18nFactory(keyset);

const FiltersForGeneralGroupNames: Record<FiltersForGeneralGroup, string> = {
    CAMPAIGN_STRATEGY: i18n('strategy'),
    CAMPAIGN_NETWORK: i18n('network'),
    MOBILE_MULTIPLIER: i18n('mobileMultipliers'),
    VIDEO_MULTIPLIER: i18n('videoMultipliers'),
    PERFORMANCE_TGO_MULTIPLIER: i18n('perfomanceMultipliers'),
    REGIONS: i18n('regions'),
    RETARGETING_MULTIPLIERS: i18n('retargeting'),
    DEMOGRAPHY_MULTIPLIERS: i18n('demography'),
    CAMPAIGN_DISABLED_DOMAINS: i18n('disabledDomains'),
    CAMPAIGN_DISABLED_SSP: i18n('disabledSsp'),
    CAMPAIGN_DISABLED_IPS: i18n('disabledIps'),
    CAMPAIGN_START_TIME: i18n('campaignStart'),
    CAMPAIGN_FINISH_TIME: i18n('campaignFinish'),
    CAMPAIGN_TIME_TARGET: i18n('timeTargeting'),
    CAMPAIGN_EXTENDED_GEOTARGETING: i18n('extendedGeo'),
    CAMPAIGN_MINUS_WORDS: i18n('minusWords'),
    CAMPAIGN_BROAD_MATCH: i18n('broadmatch'),
    CAMPAIGN_RESTRICT_FREQUENCY: i18n('restrictFrequency')
};

const FiltersForStatusesGroupNames: Record<FiltersForStatusesGroup, string> = {
    CAMPAIGN_CREATION: i18n('campaign-creation'),
    CAMPAIGN_ARCHIVED: i18n('campaign-archived'),
    CAMPAIGN_UNARCHIVED: i18n('campaign-unarchived'),
    CAMPAIGN_SHOW: i18n('campaign-show'),
    CAMPAIGN_HIDE: i18n('campaign-hide'),
    BANNERS_SHOW: i18n('banner-show'),
    BANNERS_HIDE: i18n('banner-hide'),
    BANNERS_ARCHIVED: i18n('banner-archived'),
    BANNERS_UNARCHIVED: i18n('banner-unarchived')
};

export enum LogCriteriaKey {
    cid = 'cid',
    adgroupId = 'adgroupId',
    bannerId = 'bannerId',
    userName = 'userName',
    general = 'general',
    statuses = 'statuses'
}

export const FiltersForHistotyOfChanges: Record<string, string> = {
    CID: i18n('cid'),
    GROUPS: i18n('groupNo'),
    BANNERS: i18n('bannerNo')
};

const logCriteria: Record<LogCriteriaKey, Criteria> = {
    cid: {
        title: i18n('cid'),
        key: LogCriteriaKey.cid,
        type: CriteriaType.positiveNumberSet,
        validate: validatePositiveNumberSetValue
    },
    adgroupId: {
        title: i18n('groupNo'),
        key: LogCriteriaKey.adgroupId,
        type: CriteriaType.positiveNumberSet,
        validate: validatePositiveNumberSetValue
    },
    bannerId: {
        title: i18n('bannerNo'),
        key: LogCriteriaKey.bannerId,
        type: CriteriaType.positiveNumberSet,
        validate: validatePositiveNumberSetValue
    },
    userName: {
        title: i18n('userName'),
        key: LogCriteriaKey.userName,
        type: CriteriaType.positiveNumberSet
    },
    general: {
        title: i18n('settings'),
        key: LogCriteriaKey.general,
        type: CriteriaType.enumSet,
        enumSet: getEnumSetFrom(
            FiltersForGeneralGroup,
            FiltersForGeneralGroupNames
        ),
        validate: validateEnumValue(FiltersForGeneralGroup)
    },
    statuses: {
        title: i18n('statuses'),
        key: LogCriteriaKey.statuses,
        type: CriteriaType.enumSet,
        enumSet: getEnumSetFrom(
            FiltersForStatusesGroup,
            FiltersForStatusesGroupNames
        ),
        validate: validateEnumValue(FiltersForStatusesGroup)
    }
};

function getCriteriaContainers(): CriteriaContainer[] {
    return [
        {
            title: i18n('objects'),
            key: 'objects',
            criteria: [
                LogCriteriaKey.cid,
                LogCriteriaKey.adgroupId,
                LogCriteriaKey.bannerId,
                LogCriteriaKey.userName
            ]
        },
        {
            title: i18n('changes'),
            key: 'changes',
            criteria: [LogCriteriaKey.general, LogCriteriaKey.statuses]
        }
    ].map(container => ({
        ...container,
        criteria: container.criteria
            .filter(Boolean)
            .map((key: LogCriteriaKey) => {
                return logCriteria[key];
            })
    }));
}

export const getLogCriteriaContainers = (): CriteriaContainer[] => {
    return getCriteriaContainers();
};

export const getLogCriteria = (): Array<Criteria> => {
    return Object.keys(logCriteria).map(
        (key: LogCriteriaKey): Criteria => logCriteria[key]
    );
};
